<template lang="html">

  <div class="wrapper margin-menu">
  
    <section class="intro column-center -noticias">
      <h2>Noticias</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.noticias')">Noticias</router-link>
      </nav>
    </section>
    <template v-if="data">

      <div class="ficha-noticia">

      <div class="container contenedor-noticia">

        <div class="contenedor-fecha-categoria row-between">
          <p class="fecha">{{ formatDate }}</p>
        </div>

        <h1 v-html="data.title"></h1>
        
        <div class="contenedor-imagen">
          <img :src="data.header_img.url" :alt="data.header_img_subtitle">
        </div>

        <h2 class="entradilla" v-html="data.header"></h2>

        <editor-js :object="data.object" />
      </div>

    </div>

      <!-- //MODULOS// -->

      <noticias :categoria="data.categories[0].slug"></noticias>  

    </template>

    <!-- FIN DE LA FICHA -->


    <!-- <ficha-fake v-if="!!!data"></ficha-fake> -->


  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  //import fichaFake from '@/components/view-parts/actualidad/ficha-fake';

  import noticias from '@/components/parts/noticias'

  import router from '@/router';
  
  import editorJs from '@/components/editorJs';

  //import sharelinks from '@/components/parts/share-links'

  export default {
    name: 'ficha-noticia',
    props: [],
    created() {
      this.getdata();
      // if (!!!this.noticias) {
      //   this.requestNoticias();
      // }
    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestNoticia', 'requestNoticias']),
      getdata() {

        let id = this.$route.params.id + ((!!location.search) ? location.search : '');

          this.requestNoticia(id)
            .then((result) => {
              this.data = result;
              //this.setData(result);
            })
 
      },
      setData(result) {
        if (!!result.title) {
          this.data = result;

          // document.title = this.data.titulo;
          // document.head.querySelector("[name=description]").content = this.data.entradilla;


          // if (!!this.data.img.enlace) {
          //   document.head.querySelector("[property='og:image']").content = this.data.img.enlace;
          //   document.head.querySelector("[name='twitter:image']").content = this.data.img.enlace;
          // }

          // document.head.querySelector("[property='og:title']").content = this.data.titulo
          // document.head.querySelector("[name='twitter:title']").content = this.data.titulo
          // document.head.querySelector("[name='twitter:site']").content = location.href;
          // document.head.querySelector("[property='og:description']").content = this.data.entradilla.split(0, 100);
          // document.head.querySelector("[name='twitter:description']").content = this.data.entradilla.split(0, 100);

          // window.prerenderReady = true;
        } else {
          router.push('/blog');
        }
      }
    },
    computed: {
      ...mapGetters({
        server: 'getServer',
        texts: 'getTexts',
        noticias: 'getNoticias'
      }),
      formatDate() {
        const rawDate = this.data.created_at;
        if (!rawDate) return '';

        const date = new Date(rawDate);
        if (Number.isNaN(date.getTime())) return rawDate;

        return new Intl.DateTimeFormat('es-ES', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(date);
      }
    },
    filters: {
      urlToID(value) {

        let string;

        if (value.includes('youtube')) {
          string = 'https://www.youtube.com/embed/' + value.split("?v=")[1];
        } else if (value.includes('vimeo')) {
          string = 'https://player.vimeo.com/video/' + value.split("/").pop();
        }

        return string;
      }
    },
    components: {
      'noticias': noticias,
      'editor-js': editorJs
    },
    watch: {
      '$route'() {
        this.getdata();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/ficha-noticia.vue